// app/STAK_account/account.js

(function () {
    'use strict';
    var controllerId = 'stakAccount';
    angular.module('app').controller(controllerId, ['common', 'bootstrap.dialog', '$rootScope', '$routeParams', '$uibModal', 'datacontext', 'sectionMenu', '$translate', stakAccount]);

    function stakAccount(common, bDialog, $rootScope, $routeParams, $uibModal, datacontext, sectionMenu, $translate) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard
        var vm = this;
        vm.title = 'Account';
        vm.view = 'list';       //Opzione list or detail
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection(vm.title);

        vm.currentLanguage = $translate.proposedLanguage() || $translate.use();

        vm.objName = "Account"; //Utilizzato per pannello modale
        vm.showObjPanel = false;
        vm.record = {};
        vm.risorsa = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.index = 0;
        vm.custom = false;

        vm.addDisabled = false;
        vm.exportDisabled = false;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;
        vm.super = $rootScope.isAuthorized('SUPER');

        //Elenco per Ordinamento
        vm.list = {};
        vm.list.ordine = ["Username", "Email", "Data Attivazione Desc"];
        vm.list.ordine = common.setOrdine(vm.list.ordine);
        vm.ordine = vm.list.ordine[2];
        vm.selectOrdine = function (item) {
            vm.ordine = item;
            cerca();
        };

        vm.list.lingua = [{ name: $translate.instant('Italiano'), value: 'it' }, { name: $translate.instant('Inglese'), value: 'en' }];
        vm.list.ruolo = [{ name: $translate.instant('Operatore'), value: true }, { name: $translate.instant('Commerciale'), value: false }];
        vm.list.stato = [{ n: $translate.instant('Attivo'), v: true }, { n: $translate.instant('NonAttivo'), v: false }];

        vm.list.ruoliRicerca = [{ name: $translate.instant('Operatore'), value: 1 }, { name: $translate.instant('Commerciale'), value: 0 }];

        //Elenchi dettaglio
        vm.list.gruppoAmm = [];
        vm.list.gruppoDid = [];

        vm.getRecord = getRecord;

        //Filtro
        vm.filter = {};
        vm.filter.bAttivo = 0;
        vm.filter.ruolo = -1;
        vm.filter.username = '';
        vm.filter.email = '';

        vm.fUsername;
        vm.fEmail;
        vm.fBAttivo = 0;
        vm.fRuolo = -1;

        vm.format = 'dd/MM/yyyy';        

        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll;
        vm.get = getRecord;
        vm.add = addModal;
        vm.update = updateItem;
        vm.updatePassword = updatePassword;
        vm.activate = setActive;
        vm.deactivate = setDeactive;
        vm.resetPassword = resetPassword;
        vm.invioCredenziali = invioCredenziali;
        vm.delete = deleteItem;



        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [];
            common.activateController(promises, controllerId)
                    .then(function () {
                        if ($routeParams.UserId != null) {
                            setView('detail');
                            getRecord($routeParams.UserId, 0);
                        }

                    });
        }


        //****************************************************
        // METODI 
        //****************************************************
        function setView(view) {
            return vm.view = view;
        }

        function cerca() {
            vm.records = [];
            vm.countRecords = 0;
            vm.page = 1;
            vm.filter.bAttivo = vm.fBAttivo == null ? 1 : vm.fBAttivo;
            vm.filter.ruolo = vm.fRuolo == null ? -1 : vm.fRuolo;
            vm.filter.username = vm.fUsername == null ? '' : vm.fUsername;
            vm.filter.email = vm.fEmail == null ? '' : vm.fEmail;

            vm.loading = false;
            countByFilter();
            return getAllByFilter();
        }

        function countByFilter() {
            return datacontext.stak_account_countAllByFilter(vm.filter.bAttivo, vm.filter.username, vm.filter.email, vm.filter.ruolo, 0).then(function (data) {
                if (data) {
                    vm.countRecords = data;
                }
            });
        }

        function getAllByFilter() {
            if (vm.loading === true) return;

            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;

            vm.loading = true;
            return datacontext.stak_account_getAllByFilter(vm.pageSize, vm.page, vm.filter.bAttivo, vm.filter.username, vm.filter.email, vm.filter.ruolo, 0, vm.ordine.value).then(function (data) {
                if (data.constructor === Array) {
                    vm.page++;
                    data.forEach(function (item) {
                        vm.records.push(item);
                    });
                }
                vm.loading = false;                
            });
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        function getRecord(id, index) {
            return datacontext.stak_account_get(id).then(function (data) {
                vm.index = index;
                vm.record = data;

                vm.record.DtAttivazione = common.dateToString(vm.record.DtAttivazione);              

                datacontext.risorsa_getByUsername2(data.Username).then(function (data2) {
                    vm.risorsa = data2;
                });

                vm.record.Password = '';
                vm.confPassword = '';

                setView('detail');
            });
        }

        function addRecord(id) {
            return datacontext.stak_account_get(id).then(function (data) {
                vm.records.push(data);
                vm.countRecords++;
            });
        }

        function updateItem() {
            vm.record.DtAttivazione = common.stringToDate(vm.record.DtAttivazione);
            return datacontext.stak_account_update(vm.record).then(function (data) {
                if (!data) {
                    vm.record.DtAttivazione = common.dateToString(vm.record.DtAttivazione);
                    cerca();
                    logSuccess($translate.instant('DatoSalvato'));
                }
                else
                    logError($translate.instant('ImpossibileSalvareDati'));
            });
        }

        function updatePassword() {
            if (vm.record.Password != vm.confPassword){
                logError($translate.instant('LePasswordDevonoCoincidere'));
                return;
            }

            vm.record.DtAttivazione = common.stringToDate(vm.record.DtAttivazione);
            return datacontext.stak_account_update(vm.record).then(function (data) {
                if (!data) {
                    vm.record.DtAttivazione = common.dateToString(vm.record.DtAttivazione);
                    logSuccess($translate.instant('DatoSalvato'));
                }
                else
                    logError($translate.instant('ImpossibileSalvareDati'));
            });
        }

        function setActive(id, index) {
            return datacontext.stak_account_activate(id).then(function (data) {
                if (!data) {
                    logSuccess($translate.instant('DatoSalvato'));
                    cerca();
                }
                else
                    logError($translate.instant('ImpossibileSalvareDati'));                
            });
        }

        function setDeactive(id) {
            return datacontext.stak_account_deactivate(id).then(function (data) {
                console.dir(data);
                if (!data) {
                    logSuccess($translate.instant('DatoSalvato'));
                    cerca();
                }
                else
                    logError($translate.instant('ImpossibileSalvareDati'));
            });
        }

        //Manda una email all'utente con un link di accesso al Reset Password
        //dove l'utente pu� inserire una nuova password per il suo account
        function resetPassword(item, index) {
            var msg = ' ' + $translate.instant('InvioEmailResetPassword') +' ' + item.Username;
            bDialog.confirmationDialog($translate.instant('Attenzione'), msg, 'OK').then(
						function () { //YES
                            return datacontext.stak_account_resetPassword(item.Email, item.Lingua).then(function (data) {						        
                                if (data != "204") return logError($translate.instant('ImpossibileEseguireOperazione')); 

                                logSuccess($translate.instant('OperazioneEffettuata'));
						        vm.index = index;
						    });
						},
						function () { //NO
						    //vm.record.Completed = false;
						});
        }

        function invioCredenziali(item, index) {
            var msg = ' ' + $translate.instant('InvioEmailNuoveCredenziali') + ' ' + item.Username;
            bDialog.confirmationDialog($translate.instant('Attenzione'), msg, 'OK').then(
						function () { //YES
                            return datacontext.stak_account_invioCredenziali(item.Email, item.Lingua).then(function (data) {						        
                                if (data != "204") return logError($translate.instant('ImpossibileEseguireOperazione')); 

                                logSuccess($translate.instant('OperazioneEffettuata'));
						        vm.index = index;
						    });
						},
						function () { //NO
						    //
						});
        }

        function deleteItem(item) {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/Stak_Account/modal/migrazioneDati.html?version=43',
                controller: 'migrazioneDati',
                windowClass: 'modal-wide',
                resolve: {
                    vecchioUtente: function () {
                        return item;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem) return logError($translate.instant('ErroreRimozione')); 
                var index = vm.records.indexOf(returnItem);
                vm.records.splice(index, 1);
                vm.countRecords--;

            });
            //var msg = ' l\'utente ' + item.Username;
            //bDialog.deleteDialog(msg).then(function () {
            //    return datacontext.stak_account_delete(item.Id).then(function (data) {
            //        if (data != "204") return logError('Errore durante la rimozione del dato');

            //        var index = vm.records.indexOf(item);
            //        vm.records.splice(index, 1);
            //        vm.countRecords--;
            //    });
            //});
        }

        //****************************************************
        // OPEN MODAL DIALOG
        //****************************************************
        function addModal() {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/Stak_Account/modal/accountStakeholderAdd.html?version=43',
                controller: 'accountStakeholderAdd',
                resolve: {
                    stakeholderId: function () {
                        return $rootScope.id;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem) return logError($translate.instant('ErroreCreazione')); 
                addRecord(returnItem.Id);

                logSuccess($translate.instant('DatoSalvato'));  
            });
        }

    }
})();
